import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

// Import your translation files
import enTranslation from "../localization/locales/en.json";
import jaTranslation from "../localization/locales/ja.json";
import zhTranslation from "../localization/locales/zh.json";
import { normalizeLanguageCode, supportedLanguages } from "./supportedLanguages";

// Custom language detection function
const detectBrowserLanguage = (): string => {
  // Get browser language
  const browserLang = navigator.language || (navigator as any).userLanguage;
  console.log("Detected browser language:", browserLang);

  return normalizeLanguageCode(browserLang);
};

// Initialize i18n
i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: enTranslation,
      },
      ja: {
        translation: jaTranslation,
      },
      zh: {
        translation: zhTranslation,
      },
    },
    fallbackLng: "en",
    lng: detectBrowserLanguage(), // Set initial language based on browser detection
    interpolation: {
      escapeValue: false, // React already escapes values
    },
    detection: {
      order: ["localStorage", "navigator", "htmlTag"],
      caches: ["localStorage"], // Cache the language selection
      lookupFromPathIndex: 0,
      lookupFromSubdomainIndex: 0,
      convertDetectedLanguage: normalizeLanguageCode,
    },
    supportedLngs: [...supportedLanguages],
  });

export default i18n;
